import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../utils/supabase';
import { setAdminViewMode } from '../utils/adminViewMode';

function LoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    const { error } = await supabase.auth.signInWithPassword({ email, password });
    setLoading(false);
    if (error) {
      setError(error.message);
    } else {
      // Password admin login should always use global-view mode.
      setAdminViewMode('global');
      navigate('/admin/clients');
    }
  };

  return (
    <div className="modern-container-narrow">
      <div className="modern-card" style={{ maxWidth: 400, margin: '100px auto' }}>
        <h1 className="modern-title">Admin Password Login</h1>
        <form onSubmit={handleLogin}>
          <div className="modern-mb-4">
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500', color: '#374151' }}>
              Email:
            </label>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              className="modern-input"
            />
          </div>
          <div className="modern-mb-6">
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500', color: '#374151' }}>
              Password:
            </label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
              className="modern-input"
            />
          </div>
          {error && <div className="modern-error">{error}</div>}
          <button
            type="submit"
            disabled={loading}
            className="modern-button"
            style={{ width: '100%' }}
          >
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>
        
      </div>
    </div>
  );
}

export default LoginPage; 